import React from 'react';
import classNames from 'classnames';
import _isNil from 'lodash/isNil';
import AssignDriverSelectNeverLoggedIn from './assign-driver-select-never-logged-in';
import AssignDriverSelectLoggedInInThePast from './assign-driver-select-logged-in-in-the-past';
import { Task } from '@bringg/types';

export interface Driver extends Bringg.Driver {
	disabled: boolean;
}

interface Props {
	driver: Driver;
	task: Task;
}

const isDriverNeverLoggedIn = (driver: Driver) => _isNil(driver.last_sign_in_at);

const AssignDriverSelectItem = (props: Props) => {
	const { driver, task } = props;

	return (
		<span
			className={classNames('assign-driver-select-item', {
				'assign-driver-select-item-disabled': driver.disabled
			})}
		>
			{isDriverNeverLoggedIn(driver) ? (
				<AssignDriverSelectNeverLoggedIn driverName={driver.name} />
			) : (
				<AssignDriverSelectLoggedInInThePast driver={driver} task={task} />
			)}
		</span>
	);
};

export default AssignDriverSelectItem;
